import { BuProfileEntity } from "domain/entity/BuProfile/BuProfileEntity";
import { axiosGetDataFromPublicAPI } from "domain/repository/axios/AxiosBasicImpl";
import { OAuthContext } from "hph-auth";
import Keycloak from 'keycloak-js';
import { NbisivPermission } from "presentation/constant/ANAInfo/NbisivPermission";
import { useBuConfig } from "presentation/hook/useBuConfig";
import { Suspense, useCallback, useEffect, useMemo, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
import { healthCheck } from "../HealthCheck/HealthCheckService";
import useLoginAssist from "./LoginAssist";

interface Props {
    config: string | Keycloak.KeycloakConfig;
    children: JSX.Element;
}

// const redirectUriHome = "nbisiv-home";

const Login = (props: Props) => {
    const [isAuthenticated, setAuthenticated] = useState<boolean>(false);
    const [keycloak] = useState(new Keycloak(props.config));
    const [keycloakRefreshCounter, setKeycloakRefreshCounter] = useState(1);
    const [operatingCompanies, setOperatingCompanies] = useState<string[]>([]);
    const [currentOperatingCompany, setCurrentOperatingCompany] = useState<string | null>(null);
    const [currentPrinter, setCurrentPrinter] = useState<string | null>(null);
    const [defaultEntryPoint, setDefaultEntryPoint] = useState<string | null>(null);
    const [permissions, setPermissions] = useState<{ [key: string]: NbisivPermission } | null>(null);
    // const [currentBu] = useState<string>("SAPT");
    const [country, setCountry] = useState<string>("");
    const [timezone, setTimezone] = useState<string>("");
    const loginAssist = useLoginAssist();
    // const public_uri = process.env.REACT_APP_BU_RPOFILE_URI;

    const buConfig = useBuConfig();

    const loginCallback = useCallback(async () => {
        const tokenParsed = (keycloak as any).tokenParsed;
        if (!tokenParsed) return;
        const userName = tokenParsed.preferred_username;
        if (!userName) return;

        if (userName === "support") {
            await loginAssist.getBuProfile(buConfig.operatingUnit).then((buProfile: BuProfileEntity) => {
                if (buProfile) {

                    const companies: string[] = loginAssist.getOperatingCompaniesForSupport(buProfile) ?? [];
                    setOperatingCompanies(companies);
                    setCountry(buProfile.country ?? "");
                    setTimezone(buProfile.timezone ?? "");


                    loginAssist.getUser("support").then(user => {
                        if (user) {

                            const operatingCompany = user.switchOperatingCompany && user.switchOperatingCompany !== user.defaultOperatingCompany ? user.switchOperatingCompany : user.defaultOperatingCompany
                            setCurrentOperatingCompany(operatingCompany ?? "");
                            setDefaultEntryPoint(user.defaultEntryPoint ?? "");



                            loginAssist.getUserGroup(userName).then(data => {
                                if (data) {

                                    loginAssist.getPermissionsForSupport(data, companies).then(permissions => {

                                        setPermissions(permissions);

                                    })
                                }
                            })
                        }
                    });
                }
            });
        } else {
            await loginAssist.getUser(userName).then(async user => {
                if (user) {

                    healthCheck(buConfig);

                    const operatingCompany = user.switchOperatingCompany && user.switchOperatingCompany !== user.defaultOperatingCompany ? user.switchOperatingCompany : user.defaultOperatingCompany
                    let printer = user.switchPrinter && user.switchPrinter !== user.defaultPrinter ? user.switchPrinter : user.defaultPrinter
                    setCurrentOperatingCompany(operatingCompany ?? "");
                    setDefaultEntryPoint(user.defaultEntryPoint ?? "undefined");

                    loginAssist.getUserGroup(userName).then(data => {

                        Promise.allSettled([
                            loginAssist.getBuProfile(buConfig.operatingUnit).then((buProfile: BuProfileEntity) => {
                                if (buProfile) {
                                    setCountry(buProfile.country ?? "");
                                    setTimezone(buProfile.timezone ?? "");
                                }
                            }),
                            loginAssist.getPermissionsForUser(data).then(permissions => {
                                if (permissions) {

                                    setPermissions(permissions);

                                    const compaines = loginAssist.getOperatingCompaniseForUser(permissions);
                                    setOperatingCompanies(compaines);


                                    if (!operatingCompany) {
                                        if (compaines && compaines.length > 0) {
                                            setCurrentOperatingCompany(compaines[0]);
                                        } else {
                                            setCurrentOperatingCompany(buConfig.operatingCompany);
                                        }
                                    }

                                }
                            })
                        ]);
                    })
                    if (!!!printer) {
                        const printers = await loginAssist.getPrinter().then(res => {
                            return res.map(e => e.printQueueName)
                        });
                        if (printers && printers.length > 0) {
                            printer = printers[0];
                        } else {
                            printer = "DUMMY";
                        }
                    }
                    setCurrentPrinter(printer ?? "DUMMY");
                    localStorage.setItem("CURRENT_PRINTER", printer ?? "DUMMY");
                }
            });
        }
        await loginAssist.updateLatestLoginDatetime(userName);
    }, [buConfig, keycloak, loginAssist]);

    // const healthCheck = (buConfig: any) => {
    //     if (buConfig) {
    //         if (!_.isEqual(buConfig.REACT_APP_FIELD_ENABLE.RAIL, buConfig.REACT_APP_RAIL_ENABLE)) {
    //             console.log('@@@@@ report error')
    //         }
    //     }
    // }

    const encryptDefaultBuToken = useCallback(async (userName: string, operatingUnit: string) => {
        axiosGetDataFromPublicAPI(`/encryptDefaultBuToken/${userName}/${operatingUnit}`).then((res) => {
            if (res) {

                localStorage.setItem("access_bu_token", res.data as string);
                loginCallback();
            }
        })
    }, [loginCallback]);

    useEffect(() => {
        const initKeycloak = async () => {
            await keycloak.init({
                onLoad: 'login-required',
                checkLoginIframe: false,
                pkceMethod: 'S256',
            }).then((authenticated) => {
                if (authenticated) {
                    localStorage.setItem("access_token_with_refresh", keycloak.token ?? "");
                    if (keycloak?.tokenParsed?.bu_url && !(keycloak?.tokenParsed?.bu_url.includes(window.location.hostname)) && process.env.NODE_ENV !== 'development') {
                        window.location = keycloak.tokenParsed.bu_url
                    }
                    setAuthenticated(true);
                    setKeycloakRefreshCounter(prevState => prevState + 1);

                    encryptDefaultBuToken((keycloak.tokenParsed as any).preferred_username, buConfig.operatingUnit);
                } else {
                    keycloak.login();
                }
            }).catch(() => {

            });
        }

        if (!isAuthenticated && !!buConfig.operatingUnit) {
            localStorage.removeItem("access_bu_token");
            initKeycloak();
        }
    }, [isAuthenticated, keycloak, loginCallback, encryptDefaultBuToken, buConfig.operatingUnit, buConfig]); //public_uri

    useEffect(() => {
    }, []);

    useEffect(() => {
        if (!keycloak) return;

        const refreshInterval = setInterval(() => {
            if (keycloak.tokenParsed && Date.now() > (keycloak.tokenParsed.exp ?? 0) * 1000 - 20000) {
                keycloak.updateToken(60).then((refreshed) => {
                    if (refreshed) {
                        setKeycloakRefreshCounter(prevState => prevState + 1);
                    } else {

                        keycloak.logout();
                        setAuthenticated(false);
                    }
                }).catch(() => {

                    keycloak.logout();
                    setAuthenticated(false);
                });
            }
        }, 10000); // Check every 10 seconds

        keycloak.onTokenExpired = () => {
            keycloak.updateToken(60).then((result) => {
                if (result) {
                    setKeycloakRefreshCounter(prevState => prevState + 1)
                } else {

                    keycloak.logout()
                    setAuthenticated(false)
                }
            })
                .catch(() => {

                    keycloak.logout()
                    setAuthenticated(false)
                });
        }

        return () => {
            clearInterval(refreshInterval); // Clean up interval on component unmount
        };
    }, [keycloak]);

    const memoKeycloak = useMemo(() => {
        return {
            ...keycloak as Keycloak.KeycloakInstance,
            token: keycloak!!.token,
            tokenParsed: keycloak!!.tokenParsed,
            currentOperatingCompany,
            defaultEntryPoint,
            operatingCompanies,
            permissions,
            bu: buConfig.operatingUnit,
            country: country,
            timezone: timezone,
            buToken: {
                operatingCompany: currentOperatingCompany,
                operatingUnit: buConfig.operatingUnit,
            },
            currentPrinter,
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [keycloak, keycloakRefreshCounter, currentOperatingCompany, defaultEntryPoint, operatingCompanies,
        permissions, buConfig.operatingUnit, country, timezone])

    return (
        // isAuthenticated
        //     ? permissions !== null && operatingCompanies.length > 0 && defaultEntryPoint !== null && currentOperatingCompany !== null
        //     ? <OAuthContext.Provider value={memoKeycloak}>{props.children}</OAuthContext.Provider>
        //     : <Loader Indicator="Stripe" size="Large" />
        //     : <React.Fragment></React.Fragment>
        <>
            {isAuthenticated &&
                <Suspense fallback={<Loader Indicator="Stripe" size="Large" />}>
                    <>
                        {(permissions && operatingCompanies && defaultEntryPoint && currentOperatingCompany) &&
                            <OAuthContext.Provider value={memoKeycloak}>{props.children}</OAuthContext.Provider>
                        }
                    </>
                </Suspense>
            }
        </>
    )
};

export { Login };

